import { assign } from "lodash";
import {
  QUERY_FUNDINGREQUESTS_REQUEST,
  QUERY_FUNDINGREQUESTS_SUCCESS,
  QUERY_FUNDINGREQUESTS_FAILURE
} from "../types";

const sameRequest = (state, payload) => {
  return (
    state.fundingRequests.limit === payload.limit &&
    // state.invitedCarriers.filters === payload.filters &&
    state.fundingRequests.ordering === payload.ordering
  );
};

export default (
  state = {
    fundingRequests: {
      loading: false,
      ids: [],
      id: 0
    }
  },
  action
) => {
  switch (action.type) {
    case QUERY_FUNDINGREQUESTS_REQUEST:
      return {
        ...state,
        fundingRequests: assign({}, state.fundingRequests, {
          id: action.payload.id,
          ids: [],
          loading: true,
          limit: action.payload.limit,
          ordering: action.payload.ordering,
          filters: action.payload.filters
        })
      };
    case QUERY_FUNDINGREQUESTS_SUCCESS:
      if (sameRequest(state, action.payload)) {
        return {
          fundingRequests: assign({}, state.fundingRequests, {
            loading: false,
            ids: action.payload.items,
            count: action.payload.count
          })
        };
      }
      return state;
    case QUERY_FUNDINGREQUESTS_FAILURE:
      return {
        fundingRequests: assign({}, state.fundingRequests, {
          loading: false
        })
      };
    // return state;
    default:
      return state;
  }
};
